<template>
    <div v-show="active" class="dk-content-step">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'DkContentStep',
    props: {
        /**
         * Whether or not is active
         */
        selected: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            active: false,
        };
    },
    created() {
        this.active = this.selected;
    },
};
</script>
